import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// [{ visibilityExpression, componentId }]: the first whose expression holds (current / before / after in scope)
// picks the row's component. Ids are walked like the feed map (DcDependencyWalker NESTED_COMPONENT_REFERENCE_OPTION_KEYS).
export default class FeedRowConditions extends BaseOption {
  static compiledIsRaw = true;

  static userInterfaceComponent = {
    component: inspectorTools.NONE,
  };

  static defaultValue = [];
}
